import { AloftPrice } from '@aloft/toolkit-shared';

import { CompSelectionProperty } from '../../types.ts';

export function getQualityTierPrice(property: CompSelectionProperty): AloftPrice | undefined {
  return property.salePrice ?? property.listPrice ?? property.rentRate;
}
